import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import LoadingSpinner from "./components/LoadingSpinner";
import "./App.css";
import { getOrFetch } from "./utils/apiCache";

function CategoriesSection() {
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setIsLoading(true);
        const cats = await getOrFetch(
          "categories:all",
          () =>
            axios
              .get("https://floriakw.com/wp-json/wc/v3/products/categories", {
                auth: {
                  username: "ck_39cd5450af63b97a35e502d9a0a75925866fefab",
                  password: "cs_15701bd9b4392a3b6e5a3d5fa4d326d7acb0a0bf",
                },
              })
              .then((r) => r.data.filter((cat) => cat.name !== "Uncategorized")),
          { ttlMs: 60 * 60 * 1000 }
        );
        setCategories(cats);
        setError(null);
      } catch (err) {
        console.error("Categories error:", err);
        setError("فشل في تحميل الأقسام. يرجى المحاولة مرة أخرى لاحقًا.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchCategories();
  }, []);

  if (isLoading) {
    return (
      <section className="featured-section">
        <div className="container">
          <div className="featured-header">
            <h2>أقسام المنتجات</h2>
          </div>
          <LoadingSpinner size="medium" color="black" withText={true} />
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="featured-section">
        <div className="container">
          <div className="featured-header">
            <h2>أقسام المنتجات</h2>
          </div>
          <div className="error-message">
            <p>{error}</p>
            <button 
              onClick={() => window.location.reload()} 
              className="retry-button"
            >
              إعادة المحاولة
            </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="featured-section">
      <div className="container">
        <div className="featured-header">
          <h2>أقسام المنتجات</h2>
          <Link to="/categories" className="view-all">
            عرض الجميع
          </Link>
        </div>

        {categories.length > 0 ? (
          <div className="grid">
            {categories.map((cat) => (
              <div key={cat.id} className="product-card">
                <Link to={`/category/${cat.id}`} className="image-wrapper">
                  {cat.image ? (
                    <img src={cat.image.src} alt={cat.name} />
                  ) : (
                    <div className="no-image">No Image</div>
                  )}
                </Link>
                <h3 className="product-title">
                  <Link to={`/category/${cat.id}`}>{cat.name}</Link>
                </h3>
                <p className="products-count">{cat.count} منتج</p>
              </div>
            ))}
          </div>
        ) : (
          <div className="no-products">
            <p>لا توجد أقسام متاحة حاليًا</p>
          </div>
        )}
      </div>
    </section>
  );
}

export default CategoriesSection;
